module.exports = __webpack_public_path__ + "static/media/iconShare--download.95f1d327.svg";